
<div class="breadcrumb-dev">
<button mat-icon-button class="mt-0" 
(click)="returnToQuickSearchGrid()"
style="margin-left:5px;width:300px;"
>
<mat-icon style="color:black;margin-top:7px;" >arrow_back</mat-icon>
<span class="ace-heading-text-secondary" style="position:relative;top:-3px;margin-left:5px;">Return to Invoice List</span>
</button>


    <div 
        *ngIf="this.turnOnSpinner === true"
            mode="indeterminate"
            style="width:100px;height:100px;margin:0 auto;"
        >
        <div class="spinner-wrapper">
            <mat-spinner></mat-spinner>
        </div>

    </div>

    <mat-card style="margin-top:15px;margin-left:20px;margin-right:30px;height:65px;min-height:65px;">
 
        <div class="container-fluid">
           <div class="row" style="margin-top:5px;">
               <div class="col-2">
                   <span class="ace-heading-text-secondary">Invoice Period:</span> <br /> 
                   {{invoicePeriod}}
               </div>
               <div class="col-3">
                <span class="ace-heading-text-secondary">Invoice No:</span> <br />
                    <span  class="mimic-button-hover" style="background-color:none;" 
                    (click)="onDisplayInvoice(currentInvoiceNumber, _appGeneralState.currentLotNumber, currentInvoiceDetail.entityId)" 
                    style="text-decoration:underline;">{{currentInvoiceNumber}}</span> 
               </div>
               <div class="col-3">
                <span class="ace-heading-text-secondary">Customer:</span> <br />
                   {{customerName}}
               </div>
               <div class="col-2">
                <span class="ace-heading-text-secondary">Invoice Amount:</span> <br />
                   @if(currentInvoiceDetail == null && currentInvoiceDetail == undefined){
                    N/A
                   }
                   @else
                   {
                    {{currentInvoiceDetail.rate | currency}}
                   }
               </div>
               <div class="col-2">
                   <div *ngIf="this._msgService.currentInvoiceBalance >= 0">
                    <span class="ace-heading-text-secondary">Balance: </span> <br />
                       {{this._msgService.currentInvoiceBalance | currency}}
                   </div>
                   <div *ngIf="this._msgService.currentInvoiceBalance < 0">
                    <span class="ace-heading-text-secondary">Balance: </span> <br/>
                       <span style="color:red;">({{(this._msgService.currentInvoiceBalance * -1) | currency}})</span>   
                   </div>
               </div>
           </div>
        </div>
    </mat-card>
    
<div style="height:2000px;margin-top:15px;">
<mat-tab-group class="ml-4 mr-4" style="margin-left:20px;margin-right:20px;margin-top:20px;height:2000px;">

    <mat-tab style="height:2000px;">
        <ng-template mat-tab-label>
            <span class="ace-heading-text-secondary" style="font-size:16px;">Payments / Refunds</span>
        </ng-template>

        <!-- Add Payments to Existing Invoices -->
        <app-payment [invoiceNumber]=currentInvoiceNumber></app-payment>
    
    </mat-tab>

    <mat-tab  style="height:1500px;">
        <ng-template mat-tab-label>
            <span class="ace-heading-text-secondary" style="font-size:16px;">Adjustments</span>
        </ng-template>

        <!-- Adjust Existing Invoice Line Item Balances -->
         @if(isGB){
            <app-gb-invoice-adjustments  [invoiceNumber]=currentInvoiceNumber></app-gb-invoice-adjustments>
         }
         @else
         {
            <app-mi-invoice-adjustments [invoiceNumber]=currentInvoiceNumber></app-mi-invoice-adjustments>
         }

        <!-- <app-adjust-billing  [invoiceNumber]=currentInvoiceNumber></app-adjust-billing> -->
        
    </mat-tab>

    <mat-tab style="height:2000px;">
        <ng-template mat-tab-label>
            <span class="ace-heading-text-secondary" style="font-size:16px;">Add Revenue</span>
        </ng-template>

        <!-- Add Revenue to Existing Invoices -->
        <app-add-revenue  [invoiceNumber]=currentInvoiceNumber></app-add-revenue>

    </mat-tab>

    <mat-tab style="height:2000px;">
        <ng-template mat-tab-label>
            <span class="ace-heading-text-secondary" style="font-size:16px;">Aging Comments</span>
        </ng-template>

        <!-- Display/Update Aging Comments -->
        <app-aging-comments [idetail]=currentInvoiceDetail></app-aging-comments>

    </mat-tab>

</mat-tab-group>
</div>
